"use client";
import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Provider from "./Provider";
import { usePathname } from "next/navigation";
import Header from "./Header";
import Image from "next/image";

import BeerBottle from "../../public/assets/beer-bottle-green.jpg";
import FoodJar from "../../public/assets/food-jar.jpg";
import PharmaBottle from "../../public/assets/pharma-products.jpg";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [fade, setFade] = useState(true);
  const pathname = usePathname();

  const images = [BeerBottle, FoodJar, PharmaBottle];

  // Show loader for 4s
  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 4000);
    return () => clearTimeout(timeout);
  }, [pathname]);

  // Cycle images with fade
  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setFade(false);
        setTimeout(() => {
          setCurrentImage((prev) => (prev + 1) % images.length);
          setFade(true);
        }, 300);
      }, 1200);
      return () => clearInterval(interval);
    }
  }, [loading, images.length]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gradient-to-r from-[#d42427]/60 via-[#033b6f]/60 to-[#2d87db]/60">
        {/* Outer rotating gradient ring */}
        <div className="relative w-60 h-60 flex items-center justify-center">
          <div className="absolute w-full h-full rounded-full border-8 border-transparent animate-spin-slow bg-gradient-to-tr from-[#b6dcff] via-[#ffb7b8] to-blue-500 [mask:linear-gradient(white,white)_content-box,linear-gradient(white,white)] [mask-composite:exclude] p-1"></div>

          {/* Inner circle */}
          <div className="relative w-52 h-52 flex items-center justify-center rounded-full overflow-hidden bg-white shadow-2xl animate-pulse-slow">
            <Image
              src={images[currentImage]}
              alt="Loading"
              className={`w-full h-full object-cover transition-opacity duration-500 ${
                fade ? "opacity-100" : "opacity-0"
              }`}
            />
          </div>
        </div>

        {/* Loading text with dots */}
        <div className="absolute bottom-20 text-white font-semibold text-lg tracking-wider">
          Loading
          <span className="animate-bounce delay-100">.</span>
          <span className="animate-bounce delay-200">.</span>
          <span className="animate-bounce delay-300">.</span>
        </div>
      </div>
    );
  }

  return (
    <Provider>
      <div className="sticky top-0 w-full z-50">
        <Header />
      </div>
      {children}
      <Footer />
    </Provider>
  );
};

export default Layout;
